<template>
	<transition name="modal">
	    <div class="modal-mask">
	      <div class="modal-wrapper">
	        <div class="modal-container" id="update-agreements-modal">

	          <div class="modal-header">
              <div class="title-header">
                <b>PAYMENT SUCCESSFUL - THANK YOU!</b>
              </div>
              <a class="btn btn-link pull-right close-modal" @click="$emit('close')"><i class="fa fa-close"></i></a>
	          </div>
	          <div class="info-modal">
	          	<p>Use this card for future payments?</p>
	          </div>
	          <div class="modal-body">
              <agreements-eft-table :agreementData="agreementsEFTData" :paymentInfo="paymentInfo" v-on:change="value => {selectedEftAgreements = value}"></agreements-eft-table>
	          </div>

	          <div class="modal-footer materialized">
              <section class="agreement-message">
                <p>I understand that by clicking Agree I am authorizing 24 Hour Fitness to automatically charge this card for payments based on the agreements above.</p>
              </section>
              <section class="button-container">
                <button class="btn btn-default" @click="$emit('close')">
                  Not Now
                </button>
                <button class="btn btn-primary"
                        v-bind:class="{'disabled-agree': !selectedEftAgreements.length}"
                        @click="$emit('agreeUpdate', selectedEftAgreements)"
                        :disabled="!selectedEftAgreements.length">
                  Agree
                </button>
              </section>
	          </div>
	        </div>
	      </div>
	    </div>
	  </transition>
</template>

<script>
  import AgreementsEFTTable from './AgreementsEFTTable.vue'

  export default {
    name: 'UpdateAgreementsModal',
    props: {
      agreementsEFTData: {
        type: Object,
        required: true
      },
      paymentInfo: {
        type: Object,
        required: true
      }
    },
    components: {
      'agreements-eft-table': AgreementsEFTTable
    },
    data () {
      return {
        selectedEftAgreements: []
      }
    }
  }
</script>
<style lang="scss">
  @import '~CommonBilling/css/variables';

  #update-agreements-modal {

    .modal-header {

      background-color: #E1E1E1;
      border-bottom: 0;

      @media (max-width: $screen-xs-max) {

        font-size: 0.9em;

      }

    }

    .info-modal {

      background-color: #44697d;
      color: #fff;
      text-align: left;
      padding: 10px 0 10px 15px;

      p {

        margin: 0;

      }

    }

    .modal-body {

      margin-top: 0 !important;

      @media (max-width: $screen-xs-max) {

        flex: 1;
        max-height: 100% !important;

      }

    }

    .modal-footer {

      display: flex;
      background-color: #E1E1E1;

      section {

        &.agreement-message {

          flex: 3;

          p {

            text-align: left;

            @media (max-width: $screen-xs-max) {

              text-align: justify;

            }

          }

          @media (max-width: $screen-xs-max) {

            padding: 15px 15px 0 15px;
            border-bottom: 1px solid #AAA;

          }

        }

        &.button-container {

          display: flex;
          flex: 1;
          justify-content: flex-end;
          align-items: center;

          button {

            height: min-content;
            padding-top: 5px;
            padding-bottom: 5px;

            &.btn-primary {

              border: 1px solid #EA1929;

              @media (max-width: $screen-xs-max) {

                margin-left: 0;
                margin-top: 10px;

              }

              &.disabled-agree {

                border-color: rgba(234, 25, 41, 0.15);

              }

            }

          }

          @media (max-width: $screen-xs-max) {

            flex-direction: column;
            align-items: stretch;
            padding: 15px !important;

          }

        }

      }

      @media (max-width: $screen-xs-max) {

        flex-direction: column;
        padding: 0 !important;

      };

    }

    @media (max-width: $screen-xs-max) {

      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      display: flex;
      flex-direction: column;

    }

  }

</style>



// WEBPACK FOOTER //
// node_modules/MakeAPayment/update_agreements_eft/UpdateAgreementsModal.vue